import { render, staticRenderFns } from "./DeleteCategoryForm.vue?vue&type=template&id=ab4ae02e&scoped=true&"
import script from "./DeleteCategoryForm.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCategoryForm.vue?vue&type=style&index=0&id=ab4ae02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ae02e",
  null
  
)

export default component.exports